import { useEffect, useState } from "react"
import AnimatedLetters from "../../AnimatedLetters/AnimatedLetters"
import YoutubeCard from "../../Cards/YoutubeCard/YoutubeCard"
import "./nodeJsTips.scss"
import Loader from "react-loaders"

function NodeJsTips() {
    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)
    }, [])

    return (
        <>
            <div className="container nodeJsTips-page">
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={["N", "o", "d", "e", ".", "J", "s", " ", "T", "i", "p", "s"]}
                            idx={15}
                        />
                    </h1>
                </div>
                <div className="card-container">
                    <div className="card-info">
                        <YoutubeCard header="REST API using Javascript - Express - Postman in 6 minutes" source="u3hOn8tkRqk" />
                    </div>
                </div>
            </div>
            <Loader type="pacman" />
        </>
    )
}

export default NodeJsTips